import { atom } from "jotai";

export const otherAtom = atom({});
